module.exports = __webpack_public_path__ + "a517b1488aa4cdd686f21b1d952d1321.svg";